//assets/A_Mayermoover_custom.js

class MayerMooverCheckout {
    constructor(market, lang) {
        this.MIN_SUBTOTAL_EX_VAT = 50.00;
        this.VAT_RATE = 0.22;
        this.market = market;
        this.lang = lang;
        this.observer = null;
        this.checkScheduled = false;

        this.MESSAGES = {
            it: '⚠️ Il subtotale minimo è di €50,00 + IVA per procedere al checkout.',
            de: '⚠️ Der Mindestbestellwert beträgt €50,00 zzgl. MwSt.',
            en: '⚠️ The minimum order subtotal is €50.00 excl. VAT.',
            fr: '⚠️ Le sous-total minimum est de 50,00 € HT pour passer commande.'
        };

        this.checkCartSubtotal = this.checkCartSubtotal.bind(this);
        this.scheduleCheck = this.scheduleCheck.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
            this.init();
        }
    }

    init() {
        this.checkCartSubtotal();

        if (!document.body || this.observer) return;

        this.observer = new MutationObserver(this.scheduleCheck);
        this.observer.observe(document.body, { childList: true, subtree: true });
    }

    scheduleCheck() {
        if (this.checkScheduled) return;

        this.checkScheduled = true;
        window.setTimeout(() => {
            this.checkScheduled = false;
            this.checkCartSubtotal();
        }, 100);
    }

    checkCartSubtotal() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                var totalWithVat = cart.total_price / 100;
                var subtotalExVat = (this.market === 'it')
                    ? totalWithVat / (1 + this.VAT_RATE)
                    : totalWithVat;

                var checkoutBtns = document.querySelectorAll('button[name="checkout"]');
                var notice = document.getElementById('min-order-notice');
                var text50 = this.MESSAGES[this.lang] || this.MESSAGES.en;

                if (subtotalExVat < this.MIN_SUBTOTAL_EX_VAT) {
                    checkoutBtns.forEach(btn => btn.style.display = 'none');

                    if (!notice) {
                        notice = document.createElement('div');
                        notice.id = 'min-order-notice';
                        notice.style.cssText = `
                            background: #fff3cd;
                            color: #856404;
                            border: 1px solid #ffc107;
                            border-radius: 6px;
                            padding: 12px 16px;
                            margin: 12px 0;
                            font-size: 14px;
                            text-align: center;
                            font-weight: 500;
                        `;
                        notice.textContent = text50;

                        var firstBtn = checkoutBtns[0];
                        if (firstBtn) {
                            firstBtn.parentNode.insertBefore(notice, firstBtn);
                        }
                    }
                } else {
                    checkoutBtns.forEach(btn => btn.style.display = '');
                    if (notice) notice.remove();
                }
            })
            .catch(err => console.error('Errore carrello Shopify:', err));
    }
}

class MayerMooverVariantBlock {
    constructor(lang, btnId, market, productTags, productVendor) {
        this.BTN_ID = btnId || 'ProductSubmitButton-template--25738939040090__main';
        this.lang = lang;
        this.market = (market || '').toLowerCase();
        this.productTags = Array.isArray(productTags) ? productTags : [];
        this.productVendor = (productVendor || '').toLowerCase();
        this.observer = null;
        this.lastValue = null;

        this.MESSAGES = {
            it: '🚛 Spedizione su quotazione. Contattaci per acquistare questo prodotto.',
            fr: '🚛 Expédition sur devis. Contactez-nous pour acheter ce produit.',
            de: '🚛 Versand auf Anfrage. Kontaktieren Sie uns, um dieses Produkt zu kaufen.',
            en: '🚛 Shipping on quotation. Contact us to purchase this product.'
        };

        this.checkVariantBlock = this.checkVariantBlock.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
            this.init();
        }
    }

    findButton() {
        var btn = document.getElementById(this.BTN_ID);
        if (btn) return btn;

        var selector = this.BTN_ID;
        if (!selector.startsWith('.') && !selector.startsWith('#') && !selector.startsWith('[')) {
            selector = '.' + selector;
        }

        try {
            return document.querySelector(selector);
        } catch (error) {
            console.warn('[block_carr] Selettore bottone non valido:', selector);
            return null;
        }
    }

    checkProductBlock() {
        var normalizedTags = this.productTags.map(tag => String(tag).trim().toLowerCase());
        var hasNonAcquistabile =
            normalizedTags.includes('nonaquistabile') ||
            normalizedTags.includes('nonacquistabile');
        var hasNaeOutsideItaly = normalizedTags.includes('nae') && this.market !== 'it';
        var isContainexContainer =
            normalizedTags.includes('container') &&
            this.productVendor === 'containex';

        return hasNonAcquistabile || hasNaeOutsideItaly || isContainexContainer;
    }

    checkVariantBlock() {
        var variantInput = document.querySelector('input[name="id"]');
        var btn = this.findButton();

        if (!variantInput) {
            console.warn('[block_carr] ❌ input[name="id"] non trovato');
            return;
        }

        if (!btn) {
            console.warn('[block_carr] ❌ bottone non trovato:', this.BTN_ID);
            return;
        }

        var variantId = variantInput.value;
        var variantData = window.variantMetafields
            ? window.variantMetafields[variantId]
            : null;
        var isVariantBlocked = variantData?.block_carr === true;
        var isProductBlocked = this.checkProductBlock();
        var isBlocked = isVariantBlocked || isProductBlocked;
        var notice = document.getElementById('variant-block-notice');
        var noticeText = this.MESSAGES[this.lang] || this.MESSAGES.en;

        if (isBlocked) {
            btn.disabled = true;
            btn.style.opacity = '0.5';
            btn.style.cursor = 'not-allowed';

            if (!notice) {
                notice = document.createElement('div');
                notice.id = 'variant-block-notice';
                notice.style.cssText = `
                    background: #fff3cd;
                    color: #856404;
                    border: 1px solid #ffc107;
                    border-radius: 6px;
                    padding: 12px 16px;
                    margin: 12px 0;
                    font-size: 14px;
                    text-align: center;
                    font-weight: 500;
                `;
                notice.textContent = noticeText;
                btn.parentNode.insertAdjacentElement('afterend', notice/* , btn.nextSibling */);
            }
        } else {
            btn.disabled = false;
            btn.style.opacity = '';
            btn.style.cursor = '';
            if (notice) notice.remove();
        }
    }

    init() {
        this.checkVariantBlock();

        var variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
            this.lastValue = variantInput.value;
            this.observer = new MutationObserver(() => {
                if (variantInput.value !== this.lastValue) {
                    this.lastValue = variantInput.value;
                    this.checkVariantBlock();
                }
            });
            this.observer.observe(variantInput, {
                attributes: true,
                attributeFilter: ['value']
            });
        }

        document.addEventListener('variant:changed', this.checkVariantBlock);
    }
}

class MayerMoover_custom{
    
    //PATCH PER L'APP FATTURE ITALIA
    sistemazioneFattureItalia(loc, checkout_sel, lang){

        
        var private_and_fiscal = function(fc, butt_pr, remover){
            console.log(butt_pr, remover)
            var display = '';
            if(remover){
                fc.removeAttribute('required');
                fc.setAttribute('data-input-country', 'IT');
                display='none';
            }else{
                fc.setAttribute('required', 'required');
            }
            fc.parentNode.style.display = display;
            if(butt_pr){
                butt_pr.parentNode.style.display = display;
            }
        }

        //RIMOZIONE VISIVA DEL LINK PER LA RICHIESTA DI FATTURA
        
        
        var controlla =  function(iva, paese, popup, btn_popup, event) {
            
            iva = iva.replace(/\s+/g, "").toUpperCase();

            if (iva.startsWith(paese)) {
                iva = iva.slice(paese.length);
            }

            let regex;

            switch (paese) {
                case "IT":
                    regex = /^\d{11}$/;
                    break;
                case "DE":
                    regex = /^\d{9}$/;
                    break;
                case "ES":
                    regex = /^[A-Z]\d{8}$/;
                    break;
                case "AT":
                    regex = /^[A-Z]\d{8}$/;
                    break;
                case "FR":
                    regex = /^[A-Z0-9]{11}$/;
                    break;
                case "BE":
                    regex = /^0\d{9}$/;
                    break;
                case "NL":
                    regex = /^\d{9}B\d{2}$/;
                    break;
            }

            let messaggio_sei_un_coglione_p_iva = {
                it: 'Inserire una partita iva valida',
                en: 'Please enter a valid VAT number',
                fr: 'Veuillez saisir un numéro de TVA valide',
                de: 'Bitte geben Sie eine gültige Umsatzsteuer-Identifikationsnummer ein'
            };
            
            if (!regex.test(iva)) {
                popup.querySelector('.fi-text-right p').innerText = messaggio_sei_un_coglione_p_iva[lang || 'en'];
                event.preventDefault();
            }else{
                popup.querySelector('.fi-text-right p').setAttribute('style', 'display:none;');
            }
        }

        var btn_checkout = document.querySelector(checkout_sel);
        
        //CREAZIONE DI AUTOMATISMO PER ANDARE AL CHECKOUT
        var crea_automatismo_checkout = function(btn_popup){
            btn_popup.addEventListener("click", (e) => {
                setTimeout(()=>{
                    btn_checkout.click();
                }, 1000);
            });
        }

        var attivazione_observe = function(callback, dest, config){
            var observer = new MutationObserver(callback);
            if(dest){
                observer.observe(dest, config);
            }

        }

        var sistema_nazioni = function(select_nazione, butt_pr){
            
            var fiscal_code = document.querySelector('invoice-modal invoice-data input[name="fiscal-code"]');
            var sdi = document.querySelector('invoice-modal invoice-data input[name="sdi"]');
            var pec = document.querySelector('invoice-modal invoice-data input[name="pec"]');
            
            if(select_nazione.value != 'IT'){
                private_and_fiscal(fiscal_code, butt_pr, true);
                sdi.parentNode.setAttribute('style', 'display:none;');
                pec.parentNode.setAttribute('style', 'display:none;');
            }else{
                private_and_fiscal(fiscal_code, butt_pr, false);
                sdi.parentNode.removeAttribute('style');
                pec.parentNode.removeAttribute('style');
            }
            
        }

        
        btn_checkout.addEventListener("click", (e) => {

            var config = { subtree: true, childList: true };
            var callback = function(mutationsList, observer) {
                if (document.querySelector('invoice-modal invoice-data button')) {
                    observer.disconnect();
                    var btn_popup = document.querySelector('invoice-modal invoice-data button');
                    var fiscal_code = document.querySelector('invoice-modal invoice-data input[name="fiscal-code"]');
                    var butt_pr = document.querySelector('invoice-modal invoice-data #invoice-person');

                    //RIMOZIONE VISIVA IN CASO DI MERCATO ESTERO
                    if (loc != 'it'){
                        var butt_az = document.querySelector('invoice-modal invoice-data #invoice-company');
                        butt_az.click();
                        private_and_fiscal(fiscal_code, butt_pr, true);
                    }
                    //RIMOZIONE o AGGIUNTA VISIVA IN CASO DI CAMBIO PROVENIENZA DA TENDINA AZIENDA
                    var config2 = { subtree: true, childList: true };
                    var callback2 = function(mutationsList, observer) {
                        if(document.querySelector('invoice-modal invoice-data select[name="country"]')){
                            var select_nazione = document.querySelector('invoice-modal invoice-data select[name="country"]');
                            sistema_nazioni(select_nazione, butt_pr);
                            select_nazione.addEventListener('click', (e) => {
                                sistema_nazioni(select_nazione, butt_pr);
                            });
                        }
                    }
                    
                    attivazione_observe(callback2, document.body, config2);
                    
                    var inpt_piva = document.querySelector('invoice-modal invoice-data input[name="vat"]');
                    var popup = document.querySelector('invoice-modal');

                    if(!inpt_piva.classList.contains('fi-hidden')){
                        
                        var fine_pop = document.querySelector('invoice-modal invoice-data .fi-text-right');
                        var avviso = document.createElement('p');
                        avviso.setAttribute('style', 'color: red; text-transform: uppercase;');
                        fine_pop.appendChild(avviso);
                        btn_popup.addEventListener('click', (e)=>{

                            var select_nazione = document.querySelector('invoice-modal invoice-data select[name="country"]');
                            controlla(inpt_piva.value, select_nazione.value, popup, btn_popup, e);

                        })

                    }

                    crea_automatismo_checkout(btn_popup);
                }
            };
            //Attivazione dell'observe
            attivazione_observe(callback, document.body, config);

        });
    }

    //GESTIONE DI TUTTE LE VARIE PATCH DEI PREZZI NEL FILE price.liquid
    sistemazionePrezzi(market, lang, compare_at_price, price){
        //CREAZIONE DELLE ABBREVIAZIONI IVA
        var abb_incl = {};
        var abb_escl = {
            "it": "IVA escl.",
            "en": "VAT excl.",
            "de": "zzgl. MwSt.",
            "fr": "TVA excl."
        };
        if (market == "it"){
            var abb_incl = {
            "it": "IVA incl.",
            "en": "VAT incl.",
            "de": "inkl. MwSt.",
            "fr": "TVA incl."
            };
        }else{
            var abb_incl = {
            "it": "IVA escl.",
            "en": "VAT excl.",
            "de": "zzgl. MwSt.",
            "fr": "TVA excl."
            };
        }
        //PREPARAZIONE DELLA DICITURA IN BASE ALLA LINGUA
        var dic_incl_iva = abb_incl[lang] || abb_incl['it'];
        var dic_escl_iva = abb_escl[lang] || abb_escl['it'];

        //DEFINIZIONE DELLA CLASSE NECESSARIA PER LA SISTEMAZIONE PREZZI
        var classe_prezzi = '';
        if (compare_at_price > price) {
            classe_prezzi = '.price-sale ';
        } else {
            classe_prezzi = '.price-regular ';
        }

        //TRASFORMA IL PREZZO IN NUMERO (FLOAT) PER LE VARIE OPERAZIONI
        var ripulisci_prezzo = function(testo){
            //Ripulisce il testo da tutto ciò che non è numero
            var string_prezzo = (testo.split('€')[1]) ? (((testo.split('€')[1]).includes('/')) ? testo.split('€')[1].split('/')[0] : testo.split('€')[1]) : testo;
            //Sostituisce i punti con le virgole e trasforma in numero
            return parseFloat(string_prezzo.replaceAll('.', '').replaceAll(',', '.'));
        }

        // ESEGUE TUTTE LE OPERAZIONI DI ESTRAZIONE DEL PREZZO E SCORPORO DELL'IVA
        var estraiPrezzoNetto = function(elem_prezzo) {
            //Estrapola il testo
            var testo = elem_prezzo.innerText.trim(); 
            var prezzo = ripulisci_prezzo(testo);
            if (isNaN(prezzo)) return null;
            //esegue lo scorporo dell'IVA
            var netto = (prezzo / 1.22).toFixed(2);
            //Riformalizzazione del prezzo per lo standard deciso
            var prezzo_def = new Intl.NumberFormat("it-IT", {minimumFractionDigits: 2, useGrouping: true}).format(netto);
            return "€" + prezzo_def.toString();

        }

        //GESTIONE DEI PREZZI GENERALI DI PRODOTTO CON L'AGGIORNAMENTO PER I VARI OPTIONAL AGGIUNTI
        var cambia_prezzo = function(classe_prezzi){
            //RECUPERA LE SPAN GENERALI DEI PREZZI PRODOTTO
            var span_no_iva = document.querySelector(classe_prezzi+'.prezzo-vantaggioso span');
            var span_prezzo = document.querySelector(classe_prezzi+'.prezzo-iva span');
            //ESTRAPOLA IL PREZZO AL NETTO DEL PRODOTTO
            var prezzo = estraiPrezzoNetto(span_no_iva);
            //INSERISCE IL PREZZO NELL'APPOSITO ELEMENTO
            span_prezzo.setAttribute("data-live-format",prezzo);
            span_prezzo.innerText = prezzo;
        }

        //AGGIORNAMENTO DELLA TABELLA NEW SCCONTI QUANTITÀ
        var cambia_tabella_sconti_qt = function(class_prz_def){
            var label = document.querySelectorAll('.lb-qty-selector-tier-wrapper'); 
            if(label.length > 0){                
                for(var i=0; i<label.length; i++){
                    //Estrae la percentuale di sconto della tabella sconti quantità
                    var prezzi = label[i].querySelectorAll('.money');
                    
                    for(var j=0; j<prezzi.length; j++){
                        var prezzo = prezzi[j];
                        var prezzo_netto = estraiPrezzoNetto(prezzo);
                        
                        prezzo.innerText = prezzo_netto+' '+dic_escl_iva;
                    }
                    
                }
            }
        }

        //FUNZIONE PER ATTIVARE L'OBESERVE SUI PREZZI
        var attivazione_observe = function(callback, dest, config){
            
            var observer = new MutationObserver(callback);
            if(dest){
                observer.observe(dest, config);
            }

        }

        //FUNZIONE DI PREPARAZIONE ALL'OBSERVE
        var observe_prezzo = function(){
            var prezzo_netto = document.querySelector(classe_prezzi+'.prezzo-vantaggioso');
            var config = { attributes: true, subtree: true, childList: true };
            var callback = function(mutationsList, observer) {
                for (var mutation of mutationsList) {
                    if (mutation.type === "attributes") {
                        cambia_prezzo(classe_prezzi);
                        if(market == 'it'){
                            cambia_tabella_sconti_qt(classe_prezzi);
                        }
                    }
                }
            };
            //Attivazione dell'observe
            attivazione_observe(callback, prezzo_netto, config);
        }
        
        //SERVE PER CONTROLLARE LE VARIANTI QUANDO CAMBIANO. SE SI ROMPE QUALCOSA CON IL CAMBIO VARIANTE CONTROLLA QUI.
        var observe_parente_prezzo = function(){
            var parente_prezzo = document.querySelector('.product__block--variant_picker');
            var config = { attributes: true, childList: true };
            var callback = function(mutationsList, observer) {
                for (var mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        cambia_prezzo(classe_prezzi);
                        if(market == 'it'){
                            cambia_tabella_sconti_qt(classe_prezzi);
                        }
                        observe_prezzo();
                    }
                }
            };
            //Attivazione dell'observe
            attivazione_observe(callback, parente_prezzo, config);
        }

        //FUNZIONE DI PREPARAZIONE ALL'OBSERVE PER LE PARE MENTALI DELLA PAGINA APERTA SU UN'ALTRA SCHEDA E NON VISUALIZZATA SUBITO OPTIONAL
        var observe_optional = function(classe_prezzi){
            var config = { subtree: true, childList: true };
            var callback = function(mutationsList, observer) {
                
                if (document.querySelector('.lb-carousel-products')) {
                    observer.disconnect();
                    osservaPrezzi();
                }
            };
            //Attivazione dell'observe
            attivazione_observe(callback, document.body, config);
        }

        //FUNZIONE DI PREPARAZIONE ALL'OBSERVE PER LE PARE MENTALI DELLA PAGINA APERTA SU UN'ALTRA SCHEDA E NON VISUALIZZATA SUBITO SCONTI QUANTITÀ
        var observe_tabella_sconti = function(classe_prezzi){
            var config = { subtree: true, childList: true };
            var callback = function(mutationsList, observer) {
                if (document.querySelector('.lb-qty-selector-wrapper')) {
                    observer.disconnect();
                    cambia_tabella_sconti_qt(classe_prezzi);
                }
            };
            //Attivazione dell'observe
            attivazione_observe(callback, document.body, config);
        }

        //INSERIMENTO PREZZO NETTO NELLA SCHEDA OPTIONAL
        var inserisci_prezzo_netto = function(div_prezzo){
            var prezzo_netto = estraiPrezzoNetto(div_prezzo);
            
            let div_netto = document.createElement('div');
            div_netto.className = 'prezzo-netto';
            div_netto.style.fontSize = '0.9em';
            div_netto.style.color = '#666';
            div_netto.innerHTML = prezzo_netto+' <span class="iva-escl">' + dic_escl_iva + '</span>';
            div_prezzo.parentNode.appendChild(div_netto);

        }

        //AGGIORNAMENTO DEL PREZZO NETTO NELLA SCHEDA OPTIONAL
        var aggiornaPrezzoNetto = function(div_prezzo) {
            var prezzo_netto = estraiPrezzoNetto(div_prezzo);

            if (prezzo_netto) {
                div_prezzo.parentElement.querySelector('.prezzo-netto').innerHTML = prezzo_netto+' <span class="iva-escl">' + dic_escl_iva + '</span>';
            }

        }  
        
        //INSERISCE  LA DICITURA IVA AL PREZZO NETTO NEGLI OPTIONAL
        var insert_dic_prezzo = function(ref, dic){
            var dic_IVA = document.createElement('span');
            dic_IVA.classList.add('iva-escl');
            dic_IVA.innerText = ' '+dic;
            ref.appendChild(dic_IVA);
        }

        //GESTIONE GLI EVENTI CHE DOPO IL CARICAMENTO DELLA PAGINA PER QUANTO RIGUARDA GLI OPTIONAL
        //Evento specifico tendina per cambio prezzi
        var evento_select = function(select, target){
            if(select){
            select.addEventListener('change', ()=>{
                setTimeout(() => {
                aggiornaPrezzoNetto(target);
                }, 20);
            });
            }
        }
        //Evento generale per apertura popup
        var eventi_aggiuntivi_optional = function(elem, for_price){
            elem.addEventListener('click', ()=>{
                setTimeout(() => {
                    //Recupera il nuovo parente (popup)
                    var par = document.querySelector('.lb-popup-cont-body');

                    //aggiorna e/o inserisce il prezzo netto e la dicitura iva 
                    var span_prezzo = par.querySelector('.lb-price-sale-price.money');
                    if(span_prezzo.parentNode.querySelector('.prezzo-netto')){
                        aggiornaPrezzoNetto(span_prezzo);
                    }else{
                        inserisci_prezzo_netto(span_prezzo);
                    }
                    insert_dic_prezzo(span_prezzo, dic_incl_iva);

                    //Evento change select popup
                    var select_pop = par.querySelector('.lb-variant-picker');
                    evento_select(select_pop, span_prezzo);

                }, 20);
            });

        } 


        //GESTIONE DI TUTTO QUELLO CHE RIGUARDA PREZZI E DICITURE A LIVELLO DI CARD OPTIONAL
        var osservaPrezzi = function() {

            setTimeout(function () {

            var all_opt_price = document.querySelectorAll('.lb-price-sale-price.money');
            
            all_opt_price.forEach((ref) => {

                //INSERIMENTI INIZIALI PER I PREZZI
                //Inserimento iniziale dicitura IVA
                insert_dic_prezzo(ref, dic_incl_iva);
                //Inserimento e sistemazione prezzi iniziale
                inserisci_prezzo_netto(ref);

                //Ricerca scheda optional di appartenenza
                var par =  ref.parentNode.parentNode.parentNode.parentNode;
                //Evento change select
                var select_type = par.querySelector('.lb-variant-picker');
                evento_select(select_type, ref);

                //---------Evento apertura popup---------------
                //Via link titolo
                var title = par.querySelector('.lb-card-title');
                eventi_aggiuntivi_optional(title, true);

                //Via bottone visualizza
                var button_vis = par.querySelector('.lb-button');
                if(button_vis){
                    eventi_aggiuntivi_optional(button_vis, true);
                }

            });

            }, 1000); 
        }

        //ATTIVAZIONE DEL OBSERVE PER L'AGGIORNAMENTO DEI PREZZI GENERALI DEL PRODOTTO CON QUALSIASI VARIAZIONE
        observe_prezzo(classe_prezzi);
        observe_parente_prezzo();
        //GESTIONE PREZZI OPTIONAL
        
        observe_optional(classe_prezzi);
        observe_tabella_sconti(classe_prezzi);
        
    }

    nascondiCheckoutBtn(market, lang) {
        return new MayerMooverCheckout(market, lang);
    }

    bloccaCarrello(lang, btnId, market, productTags, productVendor) {
        return new MayerMooverVariantBlock(
            lang,
            btnId,
            market,
            productTags,
            productVendor
        );
    }

}

window.MayerMoover_custom = new MayerMoover_custom();
